import {mainServer} from '../../../../variables/config'

export const request_provider = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/provider/"+id);
  return response.data.data.provider
}
